import { Plane, Text } from "@react-three/drei";
import { useMemo, useRef } from "react";
import { Mesh, Vector3 } from "three";
import { ArrowHUD } from "./arrow-hud";

type ZoneInfo = {
  id: string;
  zone_type: number;
  description: string;
  zone_min_x: number;
  zone_min_y: number;
  zone_max_x: number;
  zone_max_y: number;
};

export function ZoneItem({ zone }: { zone: ZoneInfo }) {
  const ref = useRef<Mesh | null>(null);

  const position = useMemo(() => {
    return new Vector3()
      .addVectors(
        new Vector3(zone.zone_min_x, 0.05, -zone.zone_min_y),
        new Vector3(zone.zone_max_x, 0.05, -zone.zone_max_y)
      )
      .divideScalar(2);
  }, [zone]);

  const width = zone.zone_max_x - zone.zone_min_x;
  const height = zone.zone_max_y - zone.zone_min_y;

  return (
    <>
      <group>
        <Text
          color="white"
          fontSize={0.09}
          fontWeight={500}
          position={[position.x, 10, position.z]}
          rotation={[-Math.PI / 2, 0, 0]}
          anchorX="center"
          anchorY="middle"
        >
          {zone.description}
        </Text>
        <Plane
          ref={ref}
          key={zone.id}
          args={[width, height]}
          position={position}
          rotation={[-Math.PI / 2, 0, 0]}
          material-color="rgb(34,197,94)"
          material-transparent={true}
          material-opacity={0.5}
        />
      </group>
      {["enter", "exit"].some((text) => zone.description.includes(text)) && (
        <ArrowHUD
          targetRef={ref}
          rectWidth={width}
          rectHeight={height}
          label={zone.description.includes("exit") ? "Exit" : "Enter"}
        />
      )}
    </>
  );
}
